<template>
  <v-avatar :size="size">
    <img v-if="userId" :src="avatarUrl" :alt="getDisplayName" />
    <v-icon medium v-else>{{ defaultIcon }}</v-icon>
  </v-avatar>
</template>

<script>
import { getUserAvatarUrl } from "@/services/helpers/user";
import { mapGetters } from "vuex";

export default {
  name: "userAvatar",
  computed: {
    ...mapGetters({
      getDisplayName: "currentUser/getDisplayName",
      getEmail: "currentUser/getEmail",
      getId: "currentUser/getId"
    }),
    avatarUrl() {
      return getUserAvatarUrl(this.userId);
    }
  },
  props: {
    userId: String,
    size: {
      type: [Number, String],
      default: 32
    },
    defaultIcon: {
      type: String,
      default: "account_circle"
    }
  }
};
</script>
